import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = React.forwardRef(
  ({ children, className, modifiers, style, tagType, ...props }, ref) => {
    const TagType = !tagType || tagType === 'Default' ? 'div' : tagType;
    return (
      <>
        {children && (
          <TagType ref={ref} className={`${className} ${modifiers}`} style={style} {...props}>
            {children}
          </TagType>
        )}
      </>
    );
  }
);

Wrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  modifiers: PropTypes.string,
  style: PropTypes.object,
  tagType: PropTypes.string
};

Wrapper.defaultProps = {
  className: '',
  modifiers: '',
  style: {},
  tagType: ''
};

export default Wrapper;
